import { atom } from 'recoil';

export const driverListState = atom({
  key: 'driver_list_state',
  default: {
    items: [],
    desc: null,
    order_by: null,
    total: null,
    size: 20,
    page: 0,
    screen: null,
    search_text: '',
    appeal_status: '',
  },
});
